<template>
  <tr>
    <td v-for="(header, i) in headers" :key="i" :class="`text-xs-${header.align}`">
      <div v-if="header.value == 'id'" class="layout align-center pl-3">
        {{ getObjectPath(header.value, row) }}
        <v-tooltip bottom v-if="row.type != 'soa'" class="pl-3">
          <v-icon
            v-if="row.daysTillExpired > 7 && row.daysTillExpired <= 31"
            color="amber lighten-2"
            slot="activator"
          >warning</v-icon>
          <v-icon
            v-if="row.daysTillExpired <= 7 && row.daysTillExpired > 1"
            color="orange"
            slot="activator"
          >error_outline</v-icon>
          <v-icon v-if="row.daysTillExpired <= 1" color="red" slot="activator">error</v-icon>
          <span>{{ warningMessage }}</span>
        </v-tooltip>
      </div>

      <!--DISPLAY REGULAR CELL -->
      <div
        v-if="header.text!='Actions' && header.value != 'active' && header.type != 'time' && header.type != 'date' && header.value != 'id'"
      >{{ getObjectPath(header.value, row) || '-'}}</div>
      <div v-if="header.type == 'date'">{{ makeShortDate(getObjectPath(header.value, row)) || "-" }}</div>
      <!-- <div v-if="header.value == 'expiryDate'">
                <span v-if="row.daysTillExpired <= 7" class="warning--text">{{ getObjectPath(header.value, row) || '-'}}</span>
                <span v-if="row.daysTillExpired > 7 && row.daysTillExpired <= 31" class="blue--text">{{ getObjectPath(header.value, row) || '-'}}</span>
                <span v-if="row.daysTillExpired > 31">{{ getObjectPath(header.value, row) || '-'}}</span>
                
      </div>-->

      <!--DISPLAY ACTIVE ON OR OFF BUTTON -->
      <div v-if="header.value == 'active'">
        <v-btn
          flat
          icon
          :color="getObjectPath(header.value, row) ? 'green lighten-3' : 'red lighten-3'"
          @click="editDialog = true"
        >
          <v-icon v-if="getObjectPath(header.value, row)">check_circle</v-icon>
          <v-icon v-else>highlight_off</v-icon>
        </v-btn>
      </div>

      <!-- DISPLAY CALCULATED HOURS FROM TIMES -->
      <div v-if="header.value == 'calcHours'">{{!!row.start ? hours : "-"}}</div>

      <!-- DISPLAY CALCULATED BILLABLE HOURS -->
      <div
        v-if="header.value == 'calcBillableHours'"
      >{{getBillableHours(hours, row.breaks, row.travel) || "-"}}</div>

      <!-- DISPLAY ACTIONS COLUMN -->
      <div v-if="header.text=='Actions' && (userAuthClass || $store.state.user.userAuthClass.complianceRead)" class="justify-center layout px-0">
        <v-btn flat color="grey" icon @click="editDialog = true" :disabled="!$store.state.user.userAuthClass.complianceWrite">
          <v-icon>edit</v-icon>
        </v-btn>
        <v-btn
          :disabled="!row.key"
          v-if="parent == 'ComplianceResource'"
          flat
          color="primary lighten-2"
          icon
          @click="$emit('openFile')"
        >
          <v-icon>remove_red_eye</v-icon>
        </v-btn>
        <slot name="extraAction"></slot>
        <v-btn flat color="red lighten-3" icon @click="deleteDialog = true" v-if="!noDelete" :disabled="!$store.state.user.userAuthClass.complianceWrite">
          <v-icon>delete</v-icon>
        </v-btn>
      </div>
    </td>

    <!-- EDIT DIALOG -->
    <v-dialog
      v-model="editDialog"
      max-width="700px"
      @keydown.esc="editDialog = false"
      lazy
      :persistent="persistent"
    >
      <edit-component
        title="Edit Compliance Resource"
        :is="DynamicEditComponent"
        v-bind="{[parentLower]: row }"
        @close="editDialog = false"
        v-if="editDialog"
      ></edit-component>
    </v-dialog>

    <!-- DELETE CONFIRM DIAOLOG -->
    <v-dialog
      v-model="deleteDialog"
      max-width="400px"
      @keydown.esc="deleteDialog = false"
      v-if="!noDelete"
    >
      <v-card>
        <v-card-title class="headline">
          <span>
            Really delete?
            <span class="grey--text subheading">- {{row.id}}</span>
          </span>
        </v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="grey darken-1" flat @click="deleteDialog = false">Cancel</v-btn>
          <v-btn color="red darken-1" flat @click="deleteRow(); deleteDialog = false">Delete</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </tr>
</template>

<script>
import Api from "@/services/api.js";
import { addDays } from "date-fns";
import FormatDates from "@/services/mixins/formatDates";

export default {
  mixins: [FormatDates],
  data() {
    return {
      editDialog: false,
      loading: false,
      deleteDialog: false
    };
  },
  props: {
    row: Object,
    headers: Array,
    parent: String,
    actions: Boolean,
    noDelete: Boolean,
    editComponentPath: String,
    persistent: Boolean
  },
  methods: {
    deleteRow() {
      this.loading = true;
      var routeString;

      if (
        this.parent != "Vehicle.Type" &&
        this.parent != "ComplianceResource"
      ) {
        routeString = `${this.parentLower}s/${this.row.id}`;
      } else if (this.parent == "ComplianceResource") {
        routeString = `compliance/${this.row.id}`;
      } else {
        routeString = `vehicles/types/${this.row.id}`;
      }

      Api.delete(routeString)
        .then(result => {
          this.loading = false;
          if (this.parent == "ComplianceResource") {
            this.$store.commit(`compliance/deleteFromArrayStateByValue`, {
              prop: `compliances`,
              value: this.row
            });
          } else {
            this.$store.commit(
              `${this.parentLower}s/deleteFromArrayStateByValue`,
              { prop: `${this.parentLower}s`, value: this.row }
            );
          }
          this.snack({
            text: `Compliance Resource was deleted!`,
            color: "yellow"
          });
        })
        .catch(err => {
          this.loading = false;
          this.snackError();
        });
    },
    getHoursFromTimes(start, end) {
      var hours = 0;
      var minutes = 0;
      var day = "01/01/2019 ";
      var startDateTime = new Date(day + start);
      var endDateTime = new Date(day + end);
      if (start && end) {
        if (endDateTime < startDateTime) endDateTime = addDays(endDateTime, 1);
        hours = (endDateTime - startDateTime) / 1000 / 60 / 60;
      }
      return hours.toFixed(2);
    },
    getBillableHours(hours, breaks, travel) {
      return (hours - breaks + travel).toFixed(2);
    }
  },
  computed: {
    parentLower() {
      if (this.parent.indexOf(".") !== -1) {
        var strings = this.parent.split(".");
        return strings[0].toLowerCase() + strings[1];
      } else if (this.parent == "ComplianceResource") {
        return this.parent.charAt(0).toLowerCase() + this.parent.slice(1);
      } else {
        return this.parent.toLowerCase();
      }
    },
    parentComputed() {
      if (this.parent.indexOf(".") !== -1) {
        var strings = this.parent.split(".");
        return strings[0] + strings[1];
      } else {
        return this.parent;
      }
    },
    DynamicEditComponent() {
      var path;
      !!this.editComponentPath
        ? (path = this.editComponentPath)
        : (path = this.parentLower + "s/edit" + this.parentComputed + ".vue");
      //var basePath = this.parent == "ComplianceResource" ? "modules" : "components"
      //console.log('Parent: ', this.parent);

      // return () => import('@/' + this.parent == "ComplianceResource" ? "modules" : "components" + '/' + path)
      return () => import("@/" + "modules" + "/" + path);
    },
    hours() {
      if (!!this.row.start) {
        return this.getHoursFromTimes(this.row.start, this.row.end);
      } else return 0;
    },
    warningMessage() {
      var days = this.row.daysTillExpired;
      if (days > 7 && days <= 31) {
        return `${this.row.typeDisp} will expire in ${days} days!`;
      } else if (days <= 7 && days > 1) {
        return `${this.row.typeDisp} will expire in ${days} day${
          days == 1 ? "" : "s"
        }!`;
      } else if (days <= 1) {
        return `${this.row.typeDisp.toUpperCase()} EXPIRED ON ${this.makeShortDate(
          this.row.expiryDate
        )}!`;
      }
    }
  }
};
</script>

<style>
</style>
